"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Container: {
    kind: 'Box',
    props: {
      'z-index': '5',
      flex: '0 0 auto',
      display: 'flex'
    }
  }
};
exports["default"] = _default;